
export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'simple_toggle';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$trigger 		= 	this.$el;
		this.$toggle		= 	this.$el.attr( 'data-toggle-element' )? $( '.' + this.$el.attr( 'data-toggle-element' ) ):this.$el;
		this.toggleClass    =   this.$el.attr( 'data-toggle-class' )?this.$el.attr( 'data-toggle-class' ):'open';

		this.plus 			= 	this.$el.attr( 'data-plus' )?this.$el.attr( 'data-plus' ):false; 
		this.minus 			= 	this.$el.attr( 'data-minus' )?this.$el.attr( 'data-minus' ):false; 

		this.init();
    }

    init(){
    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$trigger.on( 'click', () => this.onChange() );
		}
		else{
			this.$trigger.off( 'click', () => this.onChange() );
		}
	}

	onChange(){
		this.$toggle.toggleClass( this.toggleClass );
		if ( this.$toggle.hasClass( this.toggleClass  ) ){
			if ( this.minus ){
				this.$el.find( '.plus' ).html( this.minus );
			}
		}
		else{
			if ( this.plus ){
				this.$el.find( '.plus' ).html( this.plus );
			}
		}
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.addEvents( false );
    }

}


